module.exports = __webpack_public_path__ + "static/media/ic_update.de8dd25c.svg";